import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthService } from '../../../auth';
import { MenuItem } from '../../models';
import { MenuService, TranslationService } from '../../services';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
})
export class SideMenuComponent extends BaseComponent implements OnInit {
  isAuthenticated$: Observable<boolean>;
  menuItems$: Observable<MenuItem[]>;

  constructor(
    public translationService: TranslationService,
    public menuService: MenuService,
    private authService: AuthService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    combineLatest([this.router.events, this.isAuthenticated$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([event, isAuthenticated]) => {
        if (event instanceof NavigationEnd && isAuthenticated) {
          this.menuItems$ = this.menuService.menuItems(this.router.url);
        }
      });
  }
}
